module.exports = __webpack_public_path__ + "img/currency-fill.e43b9495.svg";